import {
  BarChartOutlined,
  FileOutlined,
  GlobalOutlined,
  MessageOutlined,
  PlusSquareOutlined,
  ProjectOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import React from 'react';
export interface SidebarNavigationItem {
  title: string;
  key: string;
  routeKey: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  isDefault?: boolean;
  subUrls?: string[];
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'menu.dealRooms',
    key: 'dealRooms',
    routeKey: 'dealRooms',
    url: `${ADMIN_BASE_BATH}/deal-rooms`,
    icon: <ProjectOutlined />,
    subUrls: [
      `${ADMIN_BASE_BATH}/deal-rooms/insight/:id`,
      `${ADMIN_BASE_BATH}/deal-rooms/deal-room-info`,
      `${ADMIN_BASE_BATH}/deal-rooms/deal-room-info/:id`,
      `${ADMIN_BASE_BATH}/deal-rooms/deal-room-attributes/:id`,
      `${ADMIN_BASE_BATH}/deal-rooms/deal-room-external-files/:id`,
      `${ADMIN_BASE_BATH}/deal-rooms/deal-room-chat/:id`,
    ],
  },
  {
    title: 'menu.chats',
    key: 'chats',
    routeKey: 'chats',
    url: `${ADMIN_BASE_BATH}/chats`,
    icon: <MessageOutlined />,
    subUrls: [`${ADMIN_BASE_BATH}/chats/:dealRoomId`],
  },
  {
    title: 'mouseflowEngagement.menuTitle',
    key: 'mouseflow-engagement',
    routeKey: 'dealRooms',
    url: `${ADMIN_BASE_BATH}/deal-rooms/engagement`,
    icon: <BarChartOutlined />,
  },
  {
    title: 'menu.files',
    key: 'files',
    routeKey: 'files',
    url: `${ADMIN_BASE_BATH}/files`,
    icon: <FileOutlined />,
  },
  {
    title: 'menu.workers',
    key: 'workers',
    routeKey: 'workers',
    url: `${ADMIN_BASE_BATH}/workers`,
    icon: <UsergroupAddOutlined />,
    subUrls: [
      `${ADMIN_BASE_BATH}/workers/personal-info`,
      `${ADMIN_BASE_BATH}/workers/personal-info/:id`,
      `${ADMIN_BASE_BATH}/workers/note-info/:id`,
    ],
  },
  {
    title: 'menu.admins',
    key: 'admins',
    routeKey: 'admins',
    url: `${ADMIN_BASE_BATH}/admins`,
    icon: <UsergroupAddOutlined />,
    subUrls: [`${ADMIN_BASE_BATH}/admins/personal-info`, `${ADMIN_BASE_BATH}/admins/personal-info/:id`],
  },
  {
    title: 'menu.clients',
    key: 'clients',
    routeKey: 'clients',
    url: `${ADMIN_BASE_BATH}/clients`,
    icon: <UserSwitchOutlined />,
    subUrls: [`${ADMIN_BASE_BATH}/clients/client-info`, `${ADMIN_BASE_BATH}/clients/client-info/:id`],
  },
  {
    title: 'menu.globalSettings',
    key: 'settings',
    routeKey: 'settings',
    icon: <PlusSquareOutlined />,
    children: [
      {
        title: 'menu.translations',
        key: 'translations',
        routeKey: 'translations',
        url: `${ADMIN_BASE_BATH}/translations`,
        icon: <GlobalOutlined />,
      },
    ],
  },
];
